import { createRouter, createWebHistory } from "vue-router";
import Tables from "../views/Tables.vue";
import Inventory from "../views/Inventory.vue"
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";

const routes = [
  {
    path: "/",
    name: "/",
    meta: {
      requiresAuth: true
    },
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    meta: {
      requiresAuth: true
    },
    component: Tables,
  },
  {
    path: "/inventory",
    name: "Inventario General",
    meta: {
      requiresAuth: true
    },
    component: Inventory,
  },
  {
    path: "/profile",
    name: "Profile",
    meta: {
      requiresAuth: true
    },
    component: Profile,
  },
  {
    path: "/signin",
    name: "Signin",
    meta: {
      requiresAuth: false
    },
    component: Signin,
  },
  {
    path: "/signup",
    name: "Signup",
    meta: {
      requiresAuth: true
    },
    component: Signup,
  },
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach( (to, from, next) => {
   const user = localStorage.getItem("user");

   const requiresAuth = to.matched.some( (record) => record.meta.requiresAuth)

   if(requiresAuth && !user)
      next({name: "Signin"});
   else
      next();
})

export default router;
